import { publicIPAddressService } from '@/components/network/public-ip-address/services/PublicIPAddressService';

const state = () => ({
  public_ip_addresses: [],
  price: {},
});

const mutations = {
  setAddresses(state: any, addresses: any) {
    state.public_ip_addresses = addresses;
  },
  setPrice(state: any, price: any) {
    state.price = price;
  },
};

const actions = {
  getAddresses({ commit, rootState }: any) {
    return publicIPAddressService
      .getPublicIPAddresses(rootState.currentWorkspace.id, rootState.currentWorkspace.currentRegionId)
      .then((data: any) => {
        commit('setAddresses', data.public_ip_addresses);
        commit('setPrice', data.price);
      });
  },
};

const getters = {
  getPublicIpAddress: (state: any, getters: any, rootState: any) => (id: number) => {
    return state.public_ip_addresses.find((item: any) => id === item.id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
